import { AlertDialogComponent } from '../alert/alert.component';
import { Component } from '@angular/core';
import { DialogCloseReason } from '../base-dialog';
import { FileModel } from '../../typescript-angular-client/model/fileModel';

export enum FileOperation {
  REPLACE,
  KEEPBOTH,
  SKIP
}

@Component({
  selector: 'alert-dublicate-file',
  templateUrl: 'alert-dublicate-file.component.html'
})
export class AlertDublicateFileComponent extends AlertDialogComponent {
  optionTitle = '';
  optionChecked = false;
  fileName: string = '';
  dialogType: FileModel.FileTypeEnum;
  isFileDialogType: boolean = false;

  constructor() {
    super();
  }

  initDialog() {
    super.initDialog();
    this.fileName = this.extraData.fileName ? this.extraData.fileName : '';
    this.dialogType = this.extraData.dialogType ? this.extraData.dialogType : FileModel.FileTypeEnum.IMAGES;
    this.isFileDialogType = this.dialogType !== FileModel.FileTypeEnum.IMAGES  ? true : false;
  }

  replace() {
    this.close({
      reason: DialogCloseReason.OK,
      data: {
        operation: FileOperation.REPLACE,
        applyAll: this.optionChecked,
        fileName: this.fileName
      }
    });
  }

  keepBoth() {
    this.close({
      reason: DialogCloseReason.OK,
      data: {
        operation: FileOperation.KEEPBOTH,
        applyAll: this.optionChecked,
        fileName: this.fileName
      }
    });
  }

  skip() {
    this.close({
      reason: DialogCloseReason.OK,
      data: {
        operation: FileOperation.SKIP,
        applyAll: this.optionChecked,
        fileName: this.fileName
      }
    });
  }
}
